/**
 * Accessibility fix (WCAG 2.4.7 — Focus Visible / general keyboard usability)
 *
 * Browsers normally auto-scroll a focused element into view. On this theme
 * that wasn't happening reliably for elements further down the page (most
 * noticeably product grid tiles below the fold) — most likely because the
 * AOS scroll-reveal animations (data-aos / aos-animate, used throughout
 * product-grid-item.liquid and elsewhere) interact with the page's scroll
 * position/timing in a way that interferes with the browser's native
 * focus-scroll behavior.
 *
 * Rather than depend on native behavior working correctly alongside AOS,
 * this explicitly scrolls any focused element into view on focus, using
 * "nearest" so it doesn't over-scroll something that's already visible.
 * Mouse/touch interactions are unaffected — this only runs on focus events,
 * which primarily come from keyboard navigation (Tab) or a screen reader.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isElementFullyInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  document.addEventListener(
    'focusin',
    function (evt) {
      var target = evt.target;
      if (!target || target === document.body || target === document.documentElement) return;

      // Only act on keyboard-driven focus, not mouse/touch clicks -- a click
      // on something already visible enough to tap shouldn't cause a
      // surprise scroll jump right after. :focus-visible is the browser's
      // own native signal for this, so it works regardless of whether
      // anything else on the page happens to toggle a class on the body.
      if (target.matches && !target.matches(':focus-visible')) return;

      if (isElementFullyInViewport(target)) return;

      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    },
    true
  );
})();
